<ng-container *ngIf="resultList.length > 0; else emptyMessage">
    <gen-chart-item-data
            *ngFor="let item of resultList"
            [data]="item"
            [widgetConfig]="widgetConfig"
            [originalData]="data"
    ></gen-chart-item-data>
</ng-container>
<ng-template #emptyMessage>
    <span class="no-data-message" *ngIf="isDataLoaded" translate>{{noDataMessage}}</span>
</ng-template>
